import React from 'react';
import { CONTAINER, SECTION_PADDING, ANCHORS } from './landingConfig';
import { Reveal } from './Reveal';

/**
 * Section 7 — how it works. Target of the hero's `See how it works` CTA, so it
 * carries `id="how"`.
 *
 * DESIGN_PLAN §1.1 specifies this section and its purpose ("remove the 'will
 * this work for me' doubt") but gives no copy for the three steps, unlike every
 * other section. The copy below was written to the plan's page-level rules
 * (§1.0): grade 5–7, under 15 words a sentence, plain verbs, and it describes
 * only things the product actually does — no numbers, no timings, no claims.
 * Replace it if a stakeholder has a preferred version.
 */
const STEPS = [
  {
    title: 'Connect your accounts',
    body: 'Sign in to DICE, AXS and TAO once. Your tickets show up in one list.',
  },
  {
    title: 'Follow who you sell for',
    body: 'Pick your venues and promoters. We email you when they put a show on sale.',
  },
  {
    title: 'Work every account at once',
    body: 'Join waitlists, send tickets and keep prices in sync without switching tabs.',
  },
];

export const StepList: React.FC = () => (
  <Reveal as="section" id={ANCHORS.how} className={SECTION_PADDING}>
    <div className={CONTAINER}>
      <h2 className="text-3xl font-bold tracking-tight text-white">How it works.</h2>
      <ol className="mt-10 grid gap-6 md:grid-cols-3">
        {STEPS.map((step, i) => (
          <li key={step.title} className="rounded-2xl border border-white/[0.06] bg-white/[0.02] p-6">
            <span className="flex h-9 w-9 items-center justify-center rounded-full border border-[#3b82f6]/25 bg-[#3b82f6]/10 text-sm font-semibold tabular-nums text-[#60a5fa]">
              {i + 1}
            </span>
            <p className="mt-4 text-base font-semibold text-white">{step.title}</p>
            <p className="mt-2 text-sm leading-relaxed text-white/60">{step.body}</p>
          </li>
        ))}
      </ol>
    </div>
  </Reveal>
);
